import { TRexObservable } from '../TRexObservable';
import { onNextFrame } from './onNextFrame';
var defaultTimer = TRexObservable({
    onSubscribe: function (subs) {
        if (!subs.length) {
            onNextFrame(defaultTimer.next);
        }
    },
    onNext: function (value, subs) {
        if (subs.length) {
            onNextFrame(defaultTimer.next);
        }
    }
});
export { defaultTimer };
